import ApplicationController from "../../application_component_controller"
import { useOutlets } from "hb/insights/use_outlets"
import { partition } from "hb/lib/collection_helpers"
import { useListen } from "hb/insights/use_listen"

export default class extends ApplicationController {
  static targets = ["legend", "legendItemTemplate", "legendDualAxesTemplate"]

  connect() {
    useListen(this)

    if (this.hasLegendItemTemplateTarget) {
      this.legendItemTemplate = this.compileElement(this.legendItemTemplateTarget);
      this.legendDualAxesTemplate = this.compileElement(this.legendDualAxesTemplateTarget);
    }

    useOutlets(this)
  }

  render(config) {
    const [left, right] = partition(config, ({axis}) => axis === "left")

    if(right?.length > 0 && left?.length > 0) {
      this.legendTarget.innerHTML = this.legendDualAxesTemplate({
        left: left?.map(this.legendItemTemplate).join("\n"),
        right: right?.map(this.legendItemTemplate).join("\n")
      })
    } else {
      this.legendTarget.innerHTML = `<div class="legend-left">${config.map(this.legendItemTemplate).join("\n")}</div>`
    }
  }

  legendEnter({target}) {
    this.emit("legendHover", {
      entered: true,
      seriesIndex: target.dataset.seriesIdx
    })
  }

  legendLeave({target}) {
    this.emit("legendHover", {
      entered: false,
      seriesIndex: target.dataset.seriesIdx
    })
  }

  legendExclusive({target, shiftKey}) {
    this.emit("legendSelected", {
      shiftKey, seriesIndex: target.closest(".legend-item").dataset.seriesIdx
    })
  }
}
